import styled from 'styled-components';

export const StyledScreen = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.l}px;
  background-color: ${({ theme }) => theme.colors.backgroundPrimary};

  > * {
    width: 100%;
    max-width: 380px;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m}px;
  margin-top: ${({ theme }) => theme.spacing.l}px;
`;

export const StyledField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;

export const StyledLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;
